export default "__VITE_ASSET__rARiZFRh__"